import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { translate } from 'react-i18next';

// Services
import { login, clearStatus } from 'store/auth/actions';
import { loginFormValidator } from 'services/validate';

// Components
import LoginView from 'views/components/LoginView';
import Header from 'components/Header';
import AppVersion from 'src/views/components/appVersion';

export class DoctorLogin extends Component {
  render() {
    return (
      <React.Fragment>
        <Header />
        <LoginView {...this.props} mainText={this.props.i18n.t('practitioner_login')} />
        <AppVersion />
      </React.Fragment>
    );
  }
}

const mapStateProps = state => ({
  auth: state.auth
});

const mapDispatchProps = dispatch => ({
  onSubmit: values => {
    dispatch(login(values));
  }
});

export default connect(
  mapStateProps,
  mapDispatchProps
)(
  reduxForm({
    form: 'doctorLogin',
    validate: loginFormValidator,
    touchOnBlur: false,
    onChange: (values, dispatch, props) => {
      if (props && props.auth && props.auth.statusText) {
        dispatch(clearStatus());
      }
    }
  })(translate()(DoctorLogin))
);
